import * as React from "react"
import type { IconProps } from "../types"

const Globinus = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "white", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="square"
          strokeWidth={2}
          d="M19.7781 4.22183L4.22173 19.7782M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM18.3639 18.364C17.1924 19.5355 13.3934 17.636 9.87864 14.1213C6.36393 10.6066 4.46443 6.8076 5.636 5.63603C6.80758 4.46446 10.6066 6.36395 14.1213 9.87867C17.636 13.3934 19.5355 17.1924 18.3639 18.364Z"
        />
      </svg>
    )
  }
)
Globinus.displayName = "Globinus"

export default Globinus